module.exports = __webpack_public_path__ + "img/ic-warning.c702a449.svg";